import { SVGProps, useId } from 'react';

const AndCharge = () => {
  return (
    <svg
      fill="none"
      height="64"
      viewBox="0 0 64 64"
      width="64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 30H48V51C48 51.5523 47.5523 52 47 52H17C16.4477 52 16 51.5523 16 51V30Z"
        fill="currentcolor"
        stroke="#C7125C"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14 24C14 23.4477 14.4477 23 15 23H49C49.5523 23 50 23.4477 50 24V29C50 29.5523 49.5523 30 49 30H15C14.4477 30 14 29.5523 14 29V24Z"
        fill="currentcolor"
        stroke="#C7125C"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M35 23L35 52L29 52L29 23L35 23Z"
        fill="currentcolor"
        stroke="#C7125C"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M40.1707 12.2213C36.3873 13.1554 33.0213 18.8397 32 23C36.596 23 42.4164 21.5072 44.7666 18.4614C47.8306 14.4906 44.7666 11.0866 40.1707 12.2213Z"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M23.8293 12.2213C27.6127 13.1554 30.9787 18.8397 32 23C27.404 23 21.5836 21.5072 19.2334 18.4614C16.1694 14.4906 19.2334 11.0866 23.8293 12.2213Z"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

const Arrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12 24.0027C18.6274 24.0027 24 18.6301 24 12.0027C24 5.37527 18.6274 0.00268555 12 0.00268555C5.37258 0.00268555 0 5.37527 0 12.0027C0 18.6301 5.37258 24.0027 12 24.0027ZM10.7945 6.5402C10.3552 6.10086 9.64287 6.10086 9.20353 6.5402C8.76419 6.97954 8.76419 7.69185 9.20353 8.13119L13.0747 12.0024L9.20353 15.8735C8.76419 16.3129 8.76419 17.0252 9.20353 17.4645C9.64287 17.9039 10.3552 17.9039 10.7945 17.4645L15.4612 12.7979C15.9005 12.3585 15.9005 11.6462 15.4612 11.2069L10.7945 6.5402Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const Business = () => {
  return (
    <svg
      fill="none"
      height="64"
      viewBox="0 0 64 64"
      width="64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill="currentcolor"
        height="29"
        rx="4"
        stroke="#C7125C"
        strokeWidth="1.5"
        width="42"
        x="11"
        y="20"
      />
      <path
        d="M11 31C11 31 15.2 35 32 35C48.8 35 53 31 53 31"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <rect
        fill="currentcolor"
        height="6"
        rx="1"
        stroke="#C7125C"
        strokeWidth="1.5"
        width="10"
        x="27"
        y="32"
      />
      <path
        d="M26 20V16C26 15.4477 26.4477 15 27 15H37C37.5523 15 38 15.4477 38 16V20"
        stroke="#C7125C"
        strokeLinecap="square"
        strokeWidth="1.5"
      />
    </svg>
  );
};

const Guide = () => {
  return (
    <svg
      fill="none"
      height="64"
      viewBox="0 0 64 64"
      width="64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 15.75C8.75 12.9886 10.9886 10.75 13.75 10.75H43.25C46.0114 10.75 48.25 12.9886 48.25 15.75V34.25C48.25 37.0114 46.0114 39.25 43.25 39.25H22.25L15.75 45.75V39.25H13.75C10.9886 39.25 8.75 37.0114 8.75 34.25V15.75Z"
        fill="currentcolor"
        stroke="#C7125C"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M55.25 27.75C55.25 24.9886 53.0114 22.75 50.25 22.75H29.75C26.9886 22.75 24.75 24.9886 24.75 27.75V43.25C24.75 46.0114 26.9886 48.25 29.75 48.25H42L48.25 54.25V48.25H50.25C53.0114 48.25 55.25 46.0114 55.25 43.25V27.75Z"
        fill="currentcolor"
        stroke="#C7125C"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M30.5 30.5H50"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M30.5 35H50"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M30.5 39.5H40"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

const MultiFamilyHouse = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="64"
      viewBox="0 0 64 64"
      width="64"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M52 22V54H12V22" fill="currentcolor" />
      <path d="M52 22V54H12V22H23L32 17.7001L41 22H52Z" fill="currentcolor" />
      <path
        d="M52 22V54H12V22"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M52 22V54H12V22H23L32 17.7001L41 22H52Z"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M38 54H26V42.5294L32 39L38 42.5294V54Z"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M55 22H41.1132L32 17.7143L22.8868 22H9L14.7457 10H49.2543L55 22Z"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M38 54H26V42.5294L32 39L38 42.5294V54Z"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M55 22H41.1132L32 17.7143L22.8868 22H9L14.7457 10H49.2543L55 22Z"
        fill="currentcolor"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9 54H55"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17 28H20"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M26 28H29"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M35 28H38"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M44 28H47"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17 34H20"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17 40H20"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17 47H20"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M26 34H29"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M35 34H38"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M44 34H47"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M44 40H47"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M44 47H47"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

const PublicCharging = () => {
  const maskId = useId();

  return (
    <svg
      fill="none"
      height="64"
      viewBox="0 0 64 64"
      width="64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 10C19 8.89543 19.8954 8 21 8H43C44.1046 8 45 8.89543 45 10V28.5V43.25C45 43.6642 44.6642 44 44.25 44V44C43.8358 44 43.5 44.3358 43.5 44.75V45.25C43.5 45.6642 43.8358 46 44.25 46V46C44.6642 46 45 46.3358 45 46.75V54C45 55.1046 44.1046 56 43 56H21C19.8954 56 19 55.1046 19 54V46.75C19 46.3358 19.3358 46 19.75 46V46C20.1642 46 20.5 45.6642 20.5 45.25V44.75C20.5 44.3358 20.1642 44 19.75 44V44C19.3358 44 19 43.6642 19 43.25V28.5V10Z"
        fill="currentcolor"
        stroke="#C7125C"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M45 50V50C47.2091 50 49 48.2091 49 46V25"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M47.7273 17H45V20.2857H47.2727C47.2727 20.2857 48.1818 22.1905 48.1818 26H50C50 21.0476 48.4848 18.4286 47.7273 17Z"
        fill="#C7125C"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <mask fill="currentcolor" id={maskId}>
        <rect height="7" rx="1" width="12" x="26" y="15" />
      </mask>
      <rect
        height="7"
        mask={`url(#${maskId})`}
        rx="1"
        stroke="#C7125C"
        strokeWidth="3"
        width="12"
        x="26"
        y="15"
      />
      <path
        d="M29 36L30.8462 29H34L32.6923 33.6667H36L30 43L32 36H29Z"
        fill="#C7125C"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

const THG = () => {
  return (
    <svg
      fill="none"
      height="64"
      viewBox="0 0 64 64"
      width="64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="32"
        cy="32"
        fill="currentcolor"
        r="20.25"
        stroke="#C7125C"
        strokeWidth="1.5"
      />
      <path
        d="M23 41L41 23"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="4"
        cy="4"
        r="3.25"
        stroke="#C7125C"
        strokeWidth="1.5"
        transform="matrix(1 0 0 -1 22 30)"
      />
      <circle
        cx="4"
        cy="4"
        r="3.25"
        stroke="#C7125C"
        strokeWidth="1.5"
        transform="matrix(1 0 0 -1 34 42)"
      />
    </svg>
  );
};

const Wallbox = () => {
  return (
    <svg
      fill="none"
      height="64"
      viewBox="0 0 65 64"
      width="65"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill="currentcolor"
        height="34.5"
        rx="3.25"
        stroke="#C7125C"
        strokeLinejoin="round"
        strokeWidth="1.5"
        width="34.5"
        x="15.25"
        y="14.75"
      />
      <path
        d="M23.9412 27.9092C23.9832 27.9092 23.9832 27.9092 24.0246 27.9092C25.3324 27.9094 25.6969 27.8799 26.1503 27.7089C26.6288 27.5285 27.15 27.1612 28.0342 26.371C29.5064 25.0553 31.4794 24.6938 33.8834 25.2553L33.932 25.2686C36.1301 25.9591 37.5667 27.7662 38.2256 30.5864C38.3919 31.2761 39.1479 31.924 40.5749 32.4785C43.9147 33.7761 45.1777 35.3131 44.1538 38.2495C43.3676 40.5042 41.41 41.3724 38.5332 40.8552C37.0837 40.6021 35.9725 39.5389 35.2072 37.7549C34.6431 36.44 33.8494 35.9429 32.6558 36.1297C29.9563 36.4289 28.0516 35.7052 27.0865 33.9143L27.0647 33.8702C26.7717 33.2191 25.8263 32.9687 24.057 33.2712C22.5312 33.5386 21.3754 32.9453 20.7751 31.5651C19.8499 29.4379 21.3464 27.9092 23.9412 27.9092Z"
        stroke="#C7125C"
        strokeWidth="1.5"
      />
      <path
        d="M32 30V49.625C32 55.9072 26.9072 61 20.625 61V61C14.3428 61 9.25 55.9072 9.25 49.625V39.4898"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M11.1818 27.5H15V33.5H11.8182C11.8182 33.5 10.5455 36.1667 10.5455 41.5H8C8 34.5667 10.1212 29.5 11.1818 27.5Z"
        fill="#C7125C"
        stroke="#C7125C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <rect fill="#C7125C" height="5" rx="1" width="5" x="29.5" y="28" />
    </svg>
  );
};

const Phone = () => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_3016_773" fill="white">
      <path d="M43 47.2341V52.0656C43 54.2374 41.2352 56 39.0606 56H20.9394C18.7648 56 17 54.2374 17 52.0656V11.9344C17 9.76262 18.7648 8 20.9394 8H39.0606C41.2352 8 43 9.76262 43 11.9344V27.6013" />
    </mask>
    <path
      d="M43 47.2341H41.5V52.0656H43H44.5V47.2341H43ZM43 52.0656H41.5C41.5 53.4072 40.4085 54.5 39.0606 54.5V56V57.5C42.0618 57.5 44.5 55.0676 44.5 52.0656H43ZM39.0606 56V54.5H20.9394V56V57.5H39.0606V56ZM20.9394 56V54.5C19.5915 54.5 18.5 53.4072 18.5 52.0656H17H15.5C15.5 55.0676 17.9382 57.5 20.9394 57.5V56ZM17 52.0656H18.5V11.9344H17H15.5V52.0656H17ZM17 11.9344H18.5C18.5 10.5928 19.5915 9.5 20.9394 9.5V8V6.5C17.9382 6.5 15.5 8.93241 15.5 11.9344H17ZM20.9394 8V9.5H39.0606V8V6.5H20.9394V8ZM39.0606 8V9.5C40.4085 9.5 41.5 10.5928 41.5 11.9344H43H44.5C44.5 8.93241 42.0618 6.5 39.0606 6.5V8ZM43 11.9344H41.5V27.6013H43H44.5V11.9344H43Z"
      fill="#C7125C"
      mask="url(#path-1-inside-1_3016_773)"
    />
    <path
      d="M47.0488 25.0915C46.5175 24.9118 45.9316 24.9353 45.4004 25.2009C44.3301 25.74 43.8926 27.0446 44.4238 28.1227C44.1582 27.5837 43.6972 27.2009 43.1738 27.0212C42.6504 26.8415 42.0566 26.8649 41.5254 27.1306C40.4551 27.6696 40.0176 28.9743 40.5488 30.0524C40.2832 29.5134 39.8223 29.1306 39.2989 28.9509C38.7754 28.7712 38.1817 28.7946 37.6504 29.0602C36.5801 29.5993 36.1426 30.904 36.6739 31.9821L32.3692 23.2165C32.1036 22.6775 31.6427 22.2947 31.1193 22.115C30.5489 21.9275 29.9161 21.9588 29.3536 22.2869C28.3458 22.8728 28.0255 24.2009 28.5412 25.2556L34.4864 37.3805L31.0646 35.7789C30.4474 35.4899 29.7677 35.5289 29.2052 35.8102C28.7755 36.0289 28.4162 36.3805 28.1974 36.857C27.6974 37.9586 28.1818 39.2476 29.2599 39.7476L39.5489 45.4585C40.6738 46.0913 41.877 46.5835 43.1426 46.8179C45.3535 47.2241 48.1191 47.1147 50.494 44.7944C54.0487 41.3179 53.0331 36.3102 52.1815 34.1149C52.0097 33.6696 48.2831 26.1696 48.2831 26.1696C48.0175 25.6306 47.5566 25.2478 47.0331 25.0681L47.0488 25.0915Z"
      stroke="#C7125C"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M22 9H38V10C38 11.1046 37.1046 12 36 12H24C22.8954 12 22 11.1046 22 10V9Z"
      fill="#C7125C"
    />
  </svg>
);

const EMobilityIcons = {
  AndCharge,
  Arrow,
  Business,
  Guide,
  MultiFamilyHouse,
  PublicCharging,
  THG,
  Wallbox,
  Phone,
};

export default EMobilityIcons;
